export default "__VITE_ASSET__BXkPjpOM__"